var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#39BF8F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.2,7.5H13.8c-3.5,0-6.8,1.4-9.2,3.8c-2.4,2.4-3.8,5.8-3.8,9.2v15.6c0,3.5,1.4,6.8,3.8,9.2 c2.4,2.4,5.8,3.8,9.2,3.8h15.6v2.6h-7.8c-0.7,0-1.4,0.3-1.8,0.8c-0.5,0.5-0.8,1.2-0.8,1.8s0.3,1.4,0.8,1.8c0.5,0.5,1.2,0.8,1.8,0.8 h20.8c0.7,0,1.4-0.3,1.8-0.8c0.5-0.5,0.8-1.2,0.8-1.8s-0.3-1.4-0.8-1.8c-0.5-0.5-1.2-0.8-1.8-0.8h-7.8v-2.6h15.6 c3.5,0,6.8-1.4,9.2-3.8c2.4-2.4,3.8-5.8,3.8-9.2V20.6c0-3.5-1.4-6.8-3.8-9.2C57,8.9,53.7,7.5,50.2,7.5z M58.1,36.2 c0,2.1-0.8,4.1-2.3,5.5c-1.5,1.5-3.5,2.3-5.5,2.3H13.8c-2.1,0-4.1-0.8-5.5-2.3c-1.5-1.5-2.3-3.5-2.3-5.5V20.6 c0-2.1,0.8-4.1,2.3-5.5s3.5-2.3,5.5-2.3h36.5c2.1,0,4.1,0.8,5.5,2.3c1.5,1.5,2.3,3.5,2.3,5.5V36.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPc);
export default __webpack_public_path__ + "static/media/pc.f5574a031cf5b75d1edfcbded9daf721.svg";
export { ForwardRef as ReactComponent };